import { Button } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import CircularSpinner from '../circularSpinner'
import './outlineButton.scss'

const OutlineButton = ({
  label,
  color,
  width,
  disabled,
  onClick,
  font,
  classes,
  loading,
  type,
  isCorporate,
}) => {
  const [translation] = useTranslation('common')
  const { Mode } = useSelector((state) => state)

  return (
    <Button
      type={type}
      variant="contained"
      onClick={onClick}
      disableElevation
      disableTouchRipple={disabled || loading}
      disabled={disabled || loading}
      className={`main-outline-button-container ${
        isCorporate
          ? 'main-outline-button-corporate'
          : `main-outline-button-container-${Mode.selectedMode}  main-outline-button-${color}-${Mode.selectedMode}`
      }   main-outline-button-${color} main-outline-button-${font} size-button-${width} ${classes}
      ${
        disabled
          ? `main-outline-button-disabled main-outline-button-disabled-${Mode.selectedMode}`
          : ''
      }`}>
      <div className="outline-button-div-container">
        <span> {translation(label)}</span>
        {loading && <CircularSpinner size={20} color="secondary" />}
      </div>
    </Button>
  )
}

export default OutlineButton
